<!--
 * @Author: 鸦雀銮翎
 * @Date: 2023-01-17 11:52:42
 * @LastEditTime: 2024-03-15 15:35:41
 * @Description:
 * @FilePath: \website\src\pages\cooperator\index.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
    <div>
        <el-image
            src="http://wwwadm.tudouec.com/profile/resource/www_img/cooperator-banner.png"
        ></el-image>
        <div class="supplier topic">
            <el-image
                src="http://wwwadm.tudouec.com/profile/resource/www_img/cooperator-supplier.png"
            ></el-image>
            <div>——中国薯网·新直采新直销平台火热进行中</div>
        </div>
        <div class="tags topic">
            <el-row :gutter="40">
                <el-col
                    :span="12"
                    v-for="(item, index) in tagList"
                    :key="index"
                >
                    <div>
                        <div>{{ item.title }}</div>
                        <div>{{ item.content }}</div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="block1">
            <div>
                <span>中国薯网</span>·新直采新直销，足不出户产品直供商家。
            </div>
            <div>
                <span>中国薯网</span>·国内首家专注马铃薯农业产业互联网平台。
            </div>
        </div>
        <div class="block2">
            <el-row align="middle" type="flex">
                <el-col :span="4">
                    <div class="title">直击行业痛点</div>
                    <div class="section">
                        您是马铃薯种植户<br />
                        您是马铃薯经纪人<br />
                        您是农业局的官员
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="content">
                        <br />苦于地头售价偏低吗？<br />
                        苦于销售不畅吗？<br />
                        亟需把本县市的马铃薯品牌推广出去吗？
                    </div>
                </el-col>
                <el-col :span="10" :offset="2">
                    <el-image
                        src="http://wwwadm.tudouec.com/profile/resource/www_img/cooperator-supplier-block2.png"
                    ></el-image>
                </el-col>
            </el-row>
        </div>
        <div class="block3">
            <el-row :gutter="50">
                <el-col :span="17">
                    <div class="title">什么是中国薯网·新直采新直销平台</div>
                    <div
                        class="content"
                        v-for="(item, index) in introduce"
                        :key="index"
                    >
                        {{ item.content }}
                    </div>
                </el-col>
                <el-col :span="7">
                    <el-image
                        src="http://wwwadm.tudouec.com/profile/resource/www_img/cooperator-supplier-block3.png"
                    ></el-image>
                </el-col>
            </el-row>
        </div>
        <div class="joinus">
            <el-row>
                <el-col :span="14">
                    <div class="title">欢迎加入我们，成为中国薯网供应商！</div>
                    <div
                        class="list"
                        v-for="(item, index) in joinusList"
                        :key="index"
                        :style="{
                            background: `url(${item.url})`,
                            'background-size': 'cover',
                        }"
                    >
                        {{ item.text }}
                    </div>
                </el-col>
                <el-col :span="10">
                    <div class="title">合作申请</div>
                    <el-form
                        ref="form"
                        :rules="rules"
                        :model="formData"
                        label-width="80px"
                    >
                        <el-form-item label="姓名" prop="name">
                            <el-input v-model="formData.name"></el-input>
                        </el-form-item>
                        <el-form-item label="电话" prop="phone">
                            <el-input
                                type="Number"
                                v-model="formData.phone"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="所在地区" prop="area">
                            <el-input v-model="formData.area"></el-input>
                        </el-form-item>
                        <el-form-item label="合作对象">
                            <el-radio-group
                                v-model="formData.partnerType"
                                text-color="#019845"
                                fill="#019845"
                            >
                                <el-radio label="farmer">种植户</el-radio>
                                <el-radio label="agent">经纪人</el-radio>
                                <el-radio label="relatedUnit"
                                    >涉农单位</el-radio
                                >
                            </el-radio-group>
                        </el-form-item>
                        <div class="submit">
                            <el-button
                                size="small"
                                @click="submitForm('form')"
                                round
                                >确认申请</el-button
                            >
                        </div>
                        <div class="tel">
                            131 9051 9139 <i class="el-icon-phone"></i>电话咨询
                        </div>
                    </el-form>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            introduce: [],
            tagList: [],
            joinusList: [],
            formData: {
                name: "",
                phone: "",
                area: "",
                partnerType: "farmer",
                statys: 0,
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入姓名",
                        trigger: "blur",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入电话",
                        trigger: "blur",
                    },
                ],
                area: [
                    {
                        required: true,
                        message: "请输入所在区域",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    mounted() {
        this.$api.getIntroduceJson("cooperator").then((res) => {
            this.introduce = res.introduce;
            this.tagList = res.tagList;
            this.joinusList = res.joinusList;
        });
        this.mapInit();
    },
    methods: {
        submitForm(formName) {
            const that = this;

            that.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = that.formData;
                    that.$api
                        .addCooperator(param)
                        .then((res) => [
                            (that.formData = that.$options.data().formData),
                        ]);
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/public.scss";
/deep/ .supplier {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    .el-image {
        width: 363px;
    }
    > div {
        font-size: 33px;
        font-weight: 600;
        color: #015e2b;
        line-height: 56px;
    }
}
.tags {
    .el-col > div {
        height: 115px;
        background-image: url("http://wwwadm.tudouec.com/profile/resource/www_img/cooperator-supplier-bg.png");
        background-size: cover;
        margin-top: 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        > div {
            transform: translateY(-10px);
        }
        :first-child {
            font-size: $font-size-xl;
            font-weight: 600;
            color: #b28928;
        }
    }
}
.block1 {
    @extend .topic;
    background-color: $color-main;
    height: 124px;
    margin-top: 64px;
    padding: {
        top: 32px;
        bottom: 32px;
    }
    * {
        color: #fff;
        line-height: 30px;
    }
    div > span {
        font-weight: 600;
    }
}
.block2 {
    @extend .topic;
    background-color: #e4ebef;
    * {
        color: $color-title;
    }
    .title,
    .section {
        font-size: $font-size-xl;
        font-weight: 600;
    }
    .section,
    .content {
        font-size: $font-size-l;
    }
    .el-image {
        height: 100%;
    }
}
.block3 {
    @extend .topic;
    padding: {
        top: 64px;
        bottom: 64px;
    }
    background-color: #1c3c2a;
    * {
        color: #ffffff;
    }
    .title {
        font-size: $font-size-l;
        font-weight: 600;
        margin-bottom: 20px;
    }
    .content {
        font-size: $font-size-m;
    }
}
.joinus {
    @extend .topic;
    padding: {
        top: 40px;
        bottom: 104px;
    }
    .title {
        color: $color-main;
        font-size: $font-size-xl;
        font-weight: 600;
        margin-bottom: 32px;
        &:nth-of-type(1) {
            padding-left: 70px;
        }
    }
    .list {
        color: $color-main;
        width: 539px;
        height: 56px;
        margin-top: 24px;
        padding-left: 77px;
        line-height: 56px;
    }

    .el-col:nth-of-type(2) {
        > .title {
            text-align: center;
        }
        border-left: 1px #ccc dashed;
        padding: 0 40px 0 80px;

        .submit {
            width: 100%;
            .el-button {
                width: 100%;
                background-color: $color-main;
                border-color: $color-main;
            }
            .el-button:focus,
            .el-button {
                color: #ffffff;
                :hover {
                    color: #ffffff;
                }
            }
        }
        .tel {
            color: $color-main;
            text-align: center;
            font-weight: 600;
            i {
                margin: 15px 0 0 26px;
            }
        }
    }
}

/deep/.el-input input::-webkit-outer-spin-button,
/deep/.el-input input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}
/deep/.el-input input[type="number"] {
    -moz-appearance: textfield;
}
/deep/.el-input .el-input__inner {
    line-height: 1px !important;
}

/deep/.el-radio__input.is-checked .el-radio__inner {
    background-color: $color-main !important;
    border-color: $color-main !important;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
    color: $color-main !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/cooperator/index.vue